<template>
  <div class="row">
    <div class="col-xs-12 col-md-6">
      <div style="min-height: 350px; height: 350px">
        <l-map
          @update:zoom="zoomUpdated"
          @update:center="centerUpdated"
          style="height: 100%; width: 100%"
          :zoom="zoom"
          :center="center"
        >
          <l-tile-layer :url="url"></l-tile-layer>
          <l-circle-marker
            :key="'radio' + index"
            v-for="(geocerca, index) in geocercas"
            :radius="parseFloat(geocerca.radio)"
            :lat-lng="geocerca.latLng"
            color="red"
          ></l-circle-marker>
          <l-marker
            :icon="markerIcon"
            draggable
            :key="'marker' + index"
            v-for="(geocerca, index) in geocercas"
            :lat-lng="geocerca.latLng"
            @update:lat-lng="(latLng) => draggedMarker(latLng, index)"
          ></l-marker>
          <l-marker
            :icon="clientIcon"
            :key="'cliente' + index"
            v-for="(cliente, index) in clientes"
            :lat-lng="[cliente.latitud, cliente.longitud]"
          ></l-marker>
        </l-map>
      </div>
    </div>
    <div class="col-xs-12 col-md-6">
      <puntos-geocercas
        @verGeocerca="verGeocerca"
        v-model="geocercas"
      ></puntos-geocercas>
      <clientes-ruta
        @verCliente="verCliente"
        v-model="clientes"
      ></clientes-ruta>
    </div>
  </div>
</template>

<script>
import PuntosGeocercas from "./PuntosGeocercas.vue";
import ClientesRuta from "./ClientesRuta.vue";
export default {
  components: {
    PuntosGeocercas,
    ClientesRuta,
  },
  props: {
    value: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    clientes: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
  },
  data: function () {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      zoom: 18,
      center: [-2.1408961, -79.9080648],
      geocercas: this.value,
      clientIcon: L.icon({
        iconUrl: url + "/images/customer.png",
        iconAnchor: [16, 16],
      }),
      markerIcon: L.icon({
        iconUrl: url + "/images/location.png",
        iconAnchor: [16, 16],
      }),
    };
  },
  mounted: function () {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = [position.coords.latitude, position.coords.longitude];
      });
    }
  },
  methods: {
    verCliente: function (index) {
      this.center = [
        this.clientes[index].latitud,
        this.clientes[index].longitud,
      ];
    },
    draggedMarker: function (latLng, index) {
      this.geocercas[index].latLng = [latLng.lat, latLng.lng];
      this.geocercas[index].latitud = latLng.lat;
      this.geocercas[index].longitud = latLng.lng;
    },
    centerUpdated(center) {
      this.center = center;
    },
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    verGeocerca: function (index) {
      let geocerca = this.geocercas[index];
      this.center = geocerca.latLng;
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/rutas/Geocercas.vue